import { SessionSummary } from '@bioliberty/lifemind';
import { RotateCcw } from 'lucide-react';
import posthog from 'posthog-js';
import { useGenerateSessionNoteMutation } from '../../../api';
import { Button } from '../../../components/Button';
import { useToaster } from '../../../hooks/useToaster';
import { Event } from '../../../lib/posthog';

export interface RegenerateSessionNoteButtonProps {
  session: SessionSummary;
}

export function RegenerateSessionNoteButton({ session }: RegenerateSessionNoteButtonProps) {
  const toast = useToaster();
  const [regenerate, { isLoading }] = useGenerateSessionNoteMutation();

  const onClick = async () => {
    if (isLoading) {
      return;
    }

    posthog.capture(Event.SessionNoteRegenerateButtonClick, { sessionId: session.sessionId });

    try {
      await regenerate({ patientId: session.patientId, sessionId: session.sessionId }).unwrap();
    } catch {
      toast.error('Failed to regenerate summary. Please try again later.');
    }
  };

  return (
    <Button variant="transparent" size="m" icon={RotateCcw} isLoading={isLoading} onClick={onClick}>
      Regenerate
    </Button>
  );
}
